<template>
  <nav class="breadcrumbs">
    <ol>
      <li :class="[{'home' : crumb.name === 'Home'}]" v-for="(crumb, index) in breadcrumbs" :key="index">
        <template v-if="crumb.path" >
          <a class="s-pointer" :href="crumb.path"><s-icon v-if="crumb.name === 'Home'" icon-font="s-icon-home-outline"/>{{ crumb.name }}</a>
        </template>
        <template v-else><a class="s-no-select s-no-pointer s-hide-mobile-l" href="">{{ crumb.name }}</a></template>
      </li>
    </ol>
  </nav>
</template>

<script setup>
import SIcon from "#root/components/SIcon.vue";

defineProps({
  breadcrumbs: {
    type: Array,
    required: true,
    // Example structure:
    // [{name: 'Blog', path: '/pulse'}, {name: 'Category Name', path: '/pulse/categories/slug'}, {name: 'Article Title'}]
  }
})
</script>
